import axios, { CancelTokenSource } from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import GovCMSService from '../../services/GovCMSService'
import Conditional from '../common/Conditional'
import FormDependencyLoaderContext from '../context/FormDependencyLoaderContext'
import './AlertsUpdates.css'

interface IAlertsUpdatesProps {
  handleErrors: (any) => void
}

const AlertsUpdates = (props: IAlertsUpdatesProps) => {
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [data, setData] = useState([])
  const loader = useContext(FormDependencyLoaderContext)

  const fetchAlerts = async (source?: CancelTokenSource) => {
    return await GovCMSService.getGovCMSNewsAlerts(source).then((response) => {
      return response.result
    })
  }

  useEffect(() => {
    loader.show()
    mountedRef.current = true
    const source = axios.CancelToken.source()
    fetchAlerts(source)
      .then((data) => {
        if (mountedRef.current) {
          setData(data)
        }
      })
      .catch((error) => {
        props.handleErrors(error)
      })
      .finally(() => {
        setIsLoading(false)
        loader.hide()
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  return (
    <Conditional if={!isLoading}>
      <div className="newsroom">
        <span className="top arrow dnd-s-mob"></span>
        <span className="bottom arrow"></span>
        <div>
          <h2>Alerts and important updates</h2>
          <div>
            <div className="featured-article articles">
              {data.length > 0 &&
                data.map((alert, index) => (
                  <div key={index}>
                    <h3>
                      <a href={alert.link} target="_blank" rel="noreferrer">
                        {alert.title}
                      </a>
                    </h3>
                    <p>{alert.body}</p>
                  </div>
                ))}
              <Conditional if={data?.length == 0}>
                <h4>There are no important updates to display.</h4>
              </Conditional>
            </div>
          </div>
        </div>
      </div>
    </Conditional>
  )
}

export default AlertsUpdates
